import { render, staticRenderFns } from "./TESTAPI.vue?vue&type=template&id=7164d782&scoped=true"
import script from "./TESTAPI.vue?vue&type=script&lang=js"
export * from "./TESTAPI.vue?vue&type=script&lang=js"
import style0 from "./TESTAPI.vue?vue&type=style&index=0&id=7164d782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164d782",
  null
  
)

export default component.exports